export default __webpack_public_path__ + "static/media/dot-red.cd6afe95.svg";